// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eKRM","name":"styles_name__2S4N7","phone":"styles_phone__2Rdgy"};